<div class="international-phone-container" [formGroup]="form">
    <app-phone-code-select [countryOptions]="countries()" formControlName="country"> </app-phone-code-select>

    @let phoneMask = phoneMaskConfig();
    <mat-form-field appearance="outline" class="w-100">
        <input
            matInput
            type="text"
            inputmode="numeric"
            formControlName="phone"
            [errorStateMatcher]="phoneErrorStateMatcher"
            [mask]="phoneMask.mask"
            [maxLength]="phoneMask.maxLength"
            [dropSpecialCharacters]="true"
            [triggerOnMaskChange]="true"
            [showMaskTyped]="false"
            (input)="onPhoneInput()" />

        @if (hasPhoneError()) {
            <mat-error>
                <app-invalid-label [label]="'phone' | translate"></app-invalid-label>
            </mat-error>
        }
    </mat-form-field>
</div>
